import React from 'react';
import { HeaderContextType } from './types';

const HeaderContext = React.createContext<HeaderContextType | undefined>(
  undefined,
);

export default HeaderContext;
